import { render, staticRenderFns } from "./ApplyLawyerOffice.vue?vue&type=template&id=015b6904"
import script from "./ApplyLawyerOffice.vue?vue&type=script&lang=js"
export * from "./ApplyLawyerOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports